export default "/images/vendor/flag-icons/flags/4x3/rw.svg?f87cd918f9cf4421e1099975b5684e78";